import React from 'react'
import reactStamp from 'react-stamp'
import HealthPage from '../../containers/Health'
import AppointmentsPage from '../../containers/Appointments'
import DevicesPage from '../../containers/Devices'
import HomePage from '../../containers/Home'
import './main-panel.css'

export default reactStamp(React).compose({

    render() {

        switch (this.props.active) {
            case 'Home':
                return (
                    <HomePage setName={this.props.setName}/>
                );
                break;
            case 'Health':
                return (
                    <HealthPage />
                );
                break;
            case 'Appointments':
                return (
                    <AppointmentsPage />
                );
                break;
            case 'Devices':
                return (
                    <DevicesPage />
                );
                break;
            default:
                break;
        }

    },
    
});


/** WEBPACK FOOTER **
 ** ./src/app/components/MainPanel/index.js
 **/